import {lazy, useMemo} from "react";
import {
    DASHBOARD,
    GROUP_MANAGEMENT,
    OPERATOR_MANAGEMENT,
    TRANSFER_LOG,
    USER_MANAGEMENT,
    USERS_LOG,
    CONFIGURATION_MANAGEMENT,
    SHOW_GROUP_MANAGEMENT,
    SECURITY_EVENTS_LOG,
    GDPR_ERASURE_LOG,
    VAULT_TRANSACTIONS,
    FORENSIC_ANALYSIS,
    CERTIFICATE_VERIFY,
} from "../../constants/routes";

const Dashboard  = lazy(() => import('../dashboard/Dashboard'));
const UserManagementClient  = lazy(() => import("../user-management-client/UserManagementClient"));
const TransferLog = lazy(() => import("../transfer-log/TransferLog"));
const OperatorManagement = lazy(() => import("../operator-management/OperatorManagement"));
const UsersLog = lazy(() => import("../users-log/UsersLog"))
const GroupManagement = lazy(() => import("../group-management/GroupManagement"));
const ConfigurationManagement = lazy(() => import("../configuration-management/ConfigurationManagement"));
const SecurityEventsLog = lazy(() => import("../security-events/SecurityEventsLog"));
const GdprErasureLog = lazy(() => import("../gdpr-erasure-log/GdprErasureLog"));
const VaultTransactions = lazy(() => import("../vault-transactions/VaultTransactions"));
const ForensicAnalysis = lazy(() => import("../forensic/ForensicAnalysis"));
const CertificateVerify = lazy(() => import("../certificate/CertificateVerify"));

const useAppRoutes = () => {

    const routes = useMemo(() => (
        [
            {
                path: DASHBOARD,
                exact: true,
                component: <Dashboard />,
                canSeeRoute: true,
            },
            {
                path: USER_MANAGEMENT,
                exact: true,
                component: <UserManagementClient />,
                canSeeRoute: true,
            },
            {
                path: GROUP_MANAGEMENT,
                exact: true,
                component: <GroupManagement />,
                canSeeRoute: SHOW_GROUP_MANAGEMENT,
                redirectTo: DASHBOARD,
            },
            {
                path: TRANSFER_LOG,
                exact: true,
                component: <TransferLog />,
                canSeeRoute: true
            },
            {
                path: OPERATOR_MANAGEMENT,
                exact: true,
                component: <OperatorManagement />,
                canSeeRoute: true
            },
            {
                path: USERS_LOG,
                exact: true,
                component: <UsersLog />,
                canSeeRoute: true
            },
            {
                path: CONFIGURATION_MANAGEMENT,
                exact: true,
                component: <ConfigurationManagement />,
                canSeeRoute: true
            },
            {
                path: SECURITY_EVENTS_LOG,
                exact: true,
                component: <SecurityEventsLog />,
                canSeeRoute: true
            },
            {
                path: GDPR_ERASURE_LOG,
                exact: true,
                component: <GdprErasureLog />,
                canSeeRoute: true
            },
            {
                path: VAULT_TRANSACTIONS,
                exact: true,
                component: <VaultTransactions />,
                canSeeRoute: true
            },
            {
                path: FORENSIC_ANALYSIS,
                exact: true,
                component: <ForensicAnalysis />,
                canSeeRoute: true
            },
            {
                path: CERTIFICATE_VERIFY,
                exact: true,
                component: <CertificateVerify />,
                canSeeRoute: true
            }
        ]
    ), []);

    return { routes };
};

export default useAppRoutes;